document.addEventListener('DOMContentLoaded', function () {
 
  const variantInput  = document.getElementById('mtm-variant-id');
  const form = document.getElementById('mtm-variant-id')?.closest('form');
  const priceElement  = document.getElementById('mtm-displayed-price');
  const variantDataEl = document.getElementById('mtm-variant-data');
  const extrasInput   = document.getElementById('mtm-extras-total');
 
  if (!form) { console.error('[MTM] Formulaire non trouvé'); return; }
 
  // ============================================================
  // VARIANTES
  // ============================================================
  let variantData = [];
  let basePrice   = 0;
 
  if (variantDataEl) {
    try {
      variantData = JSON.parse(variantDataEl.textContent);
      const baseVariant = variantData.find(v => v.title === 'Base') || variantData[0];
      basePrice = baseVariant?.price || 0;
      console.log('[MTM] Variantes chargées:', variantData.map(v => `${v.title} → ${v.price / 100}€`));
    } catch (e) { console.error('[MTM] Erreur parsing variants:', e); }
  }
 
  const VARIANT_MAPPING = [
    { variantTitle: 'Pleated + Monogramme', match: { dressShirt: 'Pleated',  monogram: 'Yes' } },
    { variantTitle: 'Marcella + Monogramme',match: { dressShirt: 'Marcella', monogram: 'Yes' } },
    { variantTitle: 'Monogramme',           match: { dressShirt: 'Standard', monogram: 'Yes' } },
    { variantTitle: 'Pleated',              match: { dressShirt: 'Pleated',  monogram: 'No'  } },
    { variantTitle: 'Marcella',             match: { dressShirt: 'Marcella', monogram: 'No'  } },
    { variantTitle: 'Base',                 match: {} },
  ];
 
  function selectVariantByTitle(title) {
    const variant = variantData.find(v => v.title === title && v.available);
    if (variant && variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      console.log(`[MTM] Variante sélectionnée : "${title}" → id ${variant.id} → ${variant.price / 100}€`);
      return variant;
    }
    console.warn(`[MTM] Variante "${title}" introuvable`);
    return null;
  }
 
  function resolveVariant() {
    const dressShirtInput = document.querySelector('[name="properties[Dress shirt option]"]:checked');
    const monogramInput   = document.querySelector('[name="properties[Monogram]"]:checked');
    const currentOptions  = {
      dressShirt: dressShirtInput?.value || 'Standard',
      monogram:   monogramInput?.value   || 'No',
    };
    for (const rule of VARIANT_MAPPING) {
      const matches = Object.entries(rule.match).every(([k, v]) => currentOptions[k] === v);
      if (matches) return selectVariantByTitle(rule.variantTitle);
    }
    const fallback = variantData.find(v => v.available);
    if (fallback && variantInput) variantInput.value = fallback.id;
    return fallback || null;
  }
 
  function getExtrasTotal() {
    let extrasCents = 0;
    document.querySelectorAll('.js-extra-option:checked').forEach(input => {
      if (input.name === 'properties[Dress shirt option]' || input.name === 'properties[Monogram]') return;
      extrasCents += Math.round(parseFloat(input.dataset.extraPrice || '0') * 100);
    });
    return extrasCents;
  }
 
  function updatePrice() {
    const variant      = resolveVariant();
    const variantPrice = variant ? variant.price : basePrice;
    const extrasCents  = getExtrasTotal();
    const totalCents   = variantPrice + extrasCents;
    if (extrasInput) extrasInput.value = (extrasCents / 100).toFixed(2);
    if (priceElement) {
      priceElement.textContent = (totalCents / 100).toLocaleString('fr-FR', {
        style: 'currency', currency: 'EUR'
      });
    }
  }
 
  // ============================================================
  // MASQUER SÉLECTEUR NATIF SHOPIFY
  // ============================================================
  document.querySelectorAll('.variant-picker__option').forEach(f => f.style.display = 'none');
 
  // ============================================================
  // ONGLETS
  // ============================================================
  const tabs         = document.querySelectorAll('.mtm-tab');
  const panels       = document.querySelectorAll('.mtm-panel');
  const unlockedTabs = new Set([1]);
 
  function goToTab(index) {
    if (!unlockedTabs.has(index)) return;
    tabs.forEach(tab => tab.classList.toggle('is-active', parseInt(tab.dataset.tab) === index));
    panels.forEach(panel => {
      const n = parseInt(panel.dataset.panel);
      panel.classList.toggle('is-active', n === index);
      if (n === index) openFirstAccordion(panel);
    });
    document.querySelector('.mtm-configurator')?.scrollIntoView({ behavior: 'smooth' });
  }
 
  function unlockTab(index) {
    unlockedTabs.add(index);
    const tab = document.querySelector(`.mtm-tab[data-tab="${index}"]`);
    if (tab) { tab.classList.remove('is-locked'); tab.classList.add('is-completed'); }
  }
 
  tabs.forEach(tab => tab.addEventListener('click', () => goToTab(parseInt(tab.dataset.tab))));
 
  // ============================================================
  // ACCORDÉONS
  // ============================================================
  function openAccordion(accordion) {
    const body = accordion.querySelector('.mtm-accordion__body');
    accordion.classList.add('is-open');
    accordion.classList.remove('is-completed');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
 
  function closeAccordion(accordion, markCompleted = true) {
    const body = accordion.querySelector('.mtm-accordion__body');
    accordion.classList.remove('is-open');
    if (markCompleted) accordion.classList.add('is-completed');
    body.style.maxHeight = '0px';
  }
 
  function openFirstAccordion(panel) {
    const accordions = panel.querySelectorAll('.mtm-accordion');
    accordions.forEach(a => closeAccordion(a, false));
    if (accordions[0]) openAccordion(accordions[0]);
  }
 
  // Clic sur header → rouvrir un accordéon complété
  document.querySelectorAll('.mtm-accordion__header').forEach(header => {
    header.addEventListener('click', () => {
      const accordion = header.closest('.mtm-accordion');
      const panel     = accordion.closest('.mtm-panel');
      if (accordion.classList.contains('is-open')) return;
      panel.querySelectorAll('.mtm-accordion.is-open').forEach(a => closeAccordion(a, true));
      openAccordion(accordion);
    });
  });
 
  // Bouton "Suivant" dans un accordéon
  document.querySelectorAll('.mtm-accordion__next').forEach(btn => {
    btn.addEventListener('click', () => {
      const accordion  = btn.closest('.mtm-accordion');
      const panel      = accordion.closest('.mtm-panel');
      const allInPanel = Array.from(panel.querySelectorAll('.mtm-accordion'));
      const nextAcc    = allInPanel[allInPanel.indexOf(accordion) + 1];
 
      // Validation panel 1
      if (parseInt(panel.dataset.panel) === 1) {
        const fullNameInput = document.querySelector('[name="properties[Full name]"]');
        const useExisting   = document.querySelector('[name="properties[Use existing measurements]"]:checked');
        if (useExisting?.value === 'Yes' && fullNameInput && !fullNameInput.value.trim()) {
          fullNameInput.classList.add('is-error');
          fullNameInput.focus();
          return;
        }
        fullNameInput?.classList.remove('is-error');
      }
 
      closeAccordion(accordion, true);
 
      if (nextAcc) {
        openAccordion(nextAcc);
        nextAcc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        // Dernier accordéon du panel → onglet suivant
        const panelIndex   = parseInt(panel.dataset.panel);
        const nextTabIndex = panelIndex + 1;
        const currentTab   = document.querySelector(`.mtm-tab[data-tab="${panelIndex}"]`);
        if (currentTab) { currentTab.classList.remove('is-active'); currentTab.classList.add('is-completed'); }
        unlockTab(nextTabIndex);
        goToTab(nextTabIndex);
      }
    });
  });
 
  // Init accordéons
  panels.forEach(panel => {
    panel.querySelectorAll('.mtm-accordion__body').forEach(body => { body.style.maxHeight = '0px'; });
    if (panel.classList.contains('is-active')) openFirstAccordion(panel);
  });
 
  // ============================================================
  // VISUALISATION CARTES
  // ============================================================
  document.querySelectorAll('.mtm-card-input').forEach(input => {
    input.addEventListener('change', () => {
      document.querySelectorAll(`.mtm-card-input[name="${input.name}"]`).forEach(i => {
        i.closest('.mtm-card')?.classList.toggle('mtm-card--active', i.checked);
      });
    });
  });
 
  // ============================================================
  // MONOGRAMME
  // ============================================================
  document.querySelectorAll('.js-monogram-toggle').forEach(toggle => {
    toggle.addEventListener('change', () => {
      const details = document.getElementById('mtm-monogram-details');
      if (details) details.style.display = toggle.value === 'Yes' ? 'block' : 'none';
      const body = toggle.closest('.mtm-accordion__body');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
      updatePrice();
    });
  });
 
  // ============================================================
  // OPTIONS & PRIX
  // ============================================================
  document.addEventListener('change', (e) => {
    if (e.target.matches('.js-extra-option, [name="properties[Dress shirt option]"], [name="properties[Monogram]"]')) {
      updatePrice();
    }
  });
 
  // ============================================================
  // STEP 1 — Mesures existantes vs nouvelles
  // ============================================================
  const useExistingRadios = document.querySelectorAll('[name="properties[Use existing measurements]"]');
  const existingBlock     = document.getElementById('mtm-existing-measurements-block');
  const collarBlock       = document.getElementById('mtm-collar-size-block');
 
  function updateStep1Visibility() {
    const selected = document.querySelector('[name="properties[Use existing measurements]"]:checked');
    if (!selected) return;
    const usesExisting = selected.value === 'Yes';
    if (existingBlock) existingBlock.style.display = usesExisting ? 'block' : 'none';
    if (collarBlock)   collarBlock.style.display   = usesExisting ? 'none'  : 'block';
    const body = (existingBlock || collarBlock)?.closest('.mtm-accordion__body');
    if (body) body.style.maxHeight = body.scrollHeight + 'px';
  }
 
  useExistingRadios.forEach(r => r.addEventListener('change', updateStep1Visibility));
  updateStep1Visibility();
 
  // ============================================================
  // REVERS
  // ============================================================
  document.querySelectorAll('[name="properties[Revers]"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const show = radio.value === 'Oui';
      const wSel = document.getElementById('hemming-width-selector');
      const lSel = document.getElementById('hemming-length-selector');
      if (wSel) wSel.style.display = show ? 'block' : 'none';
      if (lSel) lSel.style.display = show ? 'block' : 'none';
    });
  });
 
  // ============================================================
  // AJOUT AU PANIER
  // ============================================================
  form.addEventListener('submit', function (e) {
    e.preventDefault();
 
    const selectedVariantId = parseInt(variantInput?.value);
 
    // Log de diagnostic
    console.log('[MTM] Submit — variant id:', selectedVariantId);
 
    if (!selectedVariantId) {
      alert('Veuillez compléter la configuration.');
      return;
    }
 
    const formData   = new FormData(form);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && !match[1].startsWith('__')) properties[match[1]] = value;
    }
 
    // Supprimer les propriétés internes (underscore) du payload visible
    delete properties['_Extras total'];
 
    const extrasCents = getExtrasTotal();
    if (extrasCents > 0) {
      properties['Extras'] = `+${(extrasCents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}`;
    }
 
    console.log('[MTM] Properties envoyées:', properties);
 
    const submitBtn = form.querySelector('.mtm-btn-submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Ajout en cours…'; }
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1, properties }] })
    })
    .then(res => {
      if (!res.ok) return res.json().then(err => { throw err; });
      return res.json();
    })
    .then(() => { window.location.href = '/cart'; })
    .catch(err => {
      console.error('[MTM] Erreur panier complète:', err);
      alert('Erreur ajout panier : ' + (err?.description || err?.message || 'Erreur inconnue'));
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Ajouter au panier'; }
    });
  });
 
  // ============================================================
  // LAYOUT — Téléporte le configurateur hors de safe-sticky (desktop)
  // Exécuté une seule fois ici, pas de doublon
  // ============================================================
  // if (window.innerWidth >= 1000 && document.body.classList.contains('template-config-chemises')) {
  //   const productEl   = document.querySelector('.product');
  //   const productForm = document.querySelector('product-form');
  //   if (productEl && productForm) {
  //     const slot = document.createElement('div');
  //     slot.className = 'mtm-configurator-slot';
  //     productEl.appendChild(slot);
  //     slot.appendChild(productForm);
  //   }
  // }

  if (window.innerWidth >= 1000 && document.body.classList.contains('template-config-chemises')) {
  const productEl  = document.querySelector('.product');
  const formWrapper = document.querySelector('.mtm-product-form-wrapper');
  if (productEl && formWrapper) {
    productEl.appendChild(formWrapper);
  }
}
 // ============================================================
// POPIN SIZE CHART
// ============================================================
const modal     = document.getElementById('mtm-modal');
const modalBody = document.getElementById('mtm-modal__body');

function openModal(pageHandle) {
  if (!modal) return;
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  modalBody.innerHTML = '<div class="mtm-modal__loading">Chargement…</div>';

  // Fetch la page directement sans paramètre sections
  fetch(`/pages/${pageHandle}`)
    .then(res => res.text())
    .then(html => {
      const parser  = new DOMParser();
      const doc     = parser.parseFromString(html, 'text/html');
      // Essaie plusieurs sélecteurs possibles selon le thème Prestige
      const content =
        doc.querySelector('.page-content')?.innerHTML ||
        doc.querySelector('[data-page-content]')?.innerHTML ||
        doc.querySelector('.rte')?.innerHTML ||
        doc.querySelector('main .container')?.innerHTML ||
        doc.querySelector('main')?.innerHTML;

      modalBody.innerHTML = content || '<p>Contenu introuvable.</p>';
    })
    .catch(() => {
      modalBody.innerHTML = '<p>Erreur lors du chargement.</p>';
    });
}

function closeModal() {
  if (!modal) return;
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// Boutons "i"
document.querySelectorAll('.mtm-info-btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation(); // empêche de cocher la carte
    openModal(btn.dataset.page);
  });
});

// Liens "i"
document.querySelectorAll('.mtm-info-btn-link').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation(); // empêche de cocher la carte
    openModal(btn.dataset.page);
  });
});

// Fermeture
document.querySelector('.mtm-modal__close')?.addEventListener('click', closeModal);
document.querySelector('.mtm-modal__overlay')?.addEventListener('click', closeModal);
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeModal();
});

  // ============================================================
  // INIT PRIX
  // ============================================================
  updatePrice();

  // Init état visuel des cartes pré-cochées
  document.querySelectorAll('.mtm-card-input:checked').forEach(input => {
    input.closest('.mtm-card')?.classList.add('mtm-card--active');
  });
});